"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.arraymove = exports.StyledTree = void 0;
var antd_1 = require("antd");
var styled_components_1 = __importDefault(require("styled-components"));
exports.StyledTree = styled_components_1.default(antd_1.Tree)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  .ant-tree-switcher {\n    display: none;\n  }\n"], ["\n  .ant-tree-switcher {\n    display: none;\n  }\n"])));
function arraymove(arr, fromIndex, toIndex) {
    var element = arr[fromIndex];
    arr.splice(fromIndex, 1);
    arr.splice(toIndex, 0, element);
}
exports.arraymove = arraymove;
var templateObject_1;
